exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-button--primary,\n.el-button--primary:hover,\n.el-button--primary:focus {\n  background: #1286ff;\n  border-color: #1286ff;\n  color: #ffffff;\n}\n", ""]);

// exports
